import { useOne } from '@refinedev/core';
import { User } from '../types';

export default function useCurrentUser() {
  const { data, isLoading, refetch } = useOne<User>({
    resource: 'me',
    id: '',
  });

  return {
    isLoading,
    currentUser: data?.data,
    refetch,
    isSystemAdmin: data?.data?.userRole === 'SYSTEM_ADMIN',
    isServiceAdmin: data?.data?.userRole === 'SERVICE_ADMIN',
  };
}
